import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams, Toutiao } from "../../types";
import { Http } from "../../utils/http";

export interface GetToutiaoConfigParams extends ActiomCommonParams {}

export interface GetToutiaoConfigResult {
    suggestWords: Toutiao.Topic[];
    cityDistrict: Toutiao.CityDistrict | null;
    userRights: Toutiao.UserRight[];
}

export type PublishAction = CommonAction<GetToutiaoConfigParams, GetToutiaoConfigResult>;

export const getToutiaoConfig: PublishAction = async (_task, params) => {
    const cookies = params.cookies ?? [];

    const http = new Http({
        headers: {
            cookie: cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
        },
    });

    const getSuggestWords = async () => {
        try {
            const res = await http.api<{ code: number; hots: Toutiao.Topic[] }>({
                method: "get",
                url: "https://mp.toutiao.com/mp/agw/creator_helper/suggest_words",
                params: { type: 2, words: "" },
            });

            return res.code === 0 ? res.hots : [];
        } catch (_error) {
            return [];
        }
    };

    const getCityDistrict = async () => {
        try {
            const res = await http.api<{ status: number; data: Toutiao.CityDistrict }>({
                method: "get",
                url: "https://mp.toutiao.com/toutiao/normandy/mp/city_district/",
            });
            return res.status === 0 ? res.data : null;
        } catch (_error) {
            return null;
        }
    };

    const getUserRights = async () => {
        try {
            const res = await http.api<{ code: number; data: { benefit_level_info_list: Toutiao.UserRight[] } }>({
                method: "get",
                url: "https://mp.toutiao.com/mp/agw/creator_project/get_benefit_page_info",
            });
            return res.code === 0 ? res.data.benefit_level_info_list : [];
        } catch (_error) {
            return [];
        }
    };

    const [suggestWords, cityDistrict, userRights] = await Promise.all([
        getSuggestWords(),
        getCityDistrict(),
        getUserRights(),
    ]);

    return success({ suggestWords, cityDistrict, userRights });
};
